/** @module uidGenerator */
import uid from 'uid'

const uidGenerator = (size = 32) => uid(size)

export default uidGenerator
